import React from "react";

import Alert from "../../../../../shared/components/design-system/Alert";
import { ExternalLink } from "../../../../../shared/components/design-system/Button/Link";
import { LabelHeading } from "../../../../../shared/components/design-system/InputLabel";
import { CopyableText } from "../Button/specifics/CopyButton";

export function ExportDownloads({
  password,
  showZipInstructions,
  fullDataExport,
}: {
  password: string;
  showZipInstructions?: boolean;
  fullDataExport?: boolean;
}) {
  return (
    <>
      <Alert
        variant="warning"
        className="ds-mb-6"
        message="Please make a note of this password, as once you close this window you will not be able open the file without it."
      />
      {fullDataExport ? (
        <p className="ds-mb-6">
          You’ll receive an email with a download link once the data is ready, this could take a 5 to 10 minutes. The
          link is valid for 24 hours.
        </p>
      ) : null}
      <LabelHeading>The password to decrypt this file is:</LabelHeading>
      <CopyableText text={password} />

      {showZipInstructions ? (
        <p className="ds-mt-6">
          Windows computers cannot open encrypted zip files unless you install a tool like{" "}
          <ExternalLink to="https://www.7-zip.org/" label="7-Zip" />.{" "}
          <ExternalLink
            to="https://drive.google.com/file/d/1d9gRVA6l6dr3Bk875M3J235r6-q5WK0_/view"
            label="Watch this video to find out more."
          />
        </p>
      ) : null}
    </>
  );
}
